import io from "socket.io-client";
import { API_BASE_URL } from "../../config";
import {
  fetchBondNumbersHistory,
  fetchBondNumbersInvestors,
  fetchBondNumbersLanding,
  fetchBondNumbersPlayers,
  fetchBondNumbersPool,
  setBondNumbersLastSettled,
  setBondNumbersPendingRound,
} from "./bondNumbersSlice";

let socket = null;
let initialized = false;

export const initBondNumbersSocket = (dispatch) => {
  if (initialized && socket?.connected) return socket;
  initialized = true;

  if (!socket) {
    socket = io(API_BASE_URL, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 30000,
      upgrade: false,
      forceNew: false,
      withCredentials: false,
    });
  }

  socket.off("connect");
  socket.off("bond-numbers:round:pending");
  socket.off("bond-numbers:round:settled");
  socket.off("bond-numbers:pool:update");
  socket.off("bond-numbers:investors:update");
  socket.off("bond-numbers:players:update");

  socket.on("connect", () => {
    dispatch(fetchBondNumbersLanding());
    dispatch(fetchBondNumbersPool());
    dispatch(fetchBondNumbersPlayers({ limit: 100 }));
  });

  socket.on("bond-numbers:round:pending", (round) => {
    dispatch(setBondNumbersPendingRound(round));
  });

  socket.on("bond-numbers:round:settled", (round) => {
    dispatch(setBondNumbersPendingRound(null));
    dispatch(setBondNumbersLastSettled(round));
    dispatch(fetchBondNumbersPool());
    dispatch(fetchBondNumbersInvestors({ limit: 100 }));
    dispatch(fetchBondNumbersPlayers({ limit: 100 }));
    dispatch(fetchBondNumbersHistory({ limit: 6 }));
  });

  socket.on("bond-numbers:pool:update", () => {
    dispatch(fetchBondNumbersPool());
    dispatch(fetchBondNumbersInvestors({ limit: 100 }));
    dispatch(fetchBondNumbersPlayers({ limit: 100 }));
  });

  socket.on("bond-numbers:investors:update", () => {
    dispatch(fetchBondNumbersInvestors({ limit: 100 }));
  });

  socket.on("bond-numbers:players:update", () => {
    dispatch(fetchBondNumbersPlayers({ limit: 100 }));
  });

  if (!socket.connected) socket.connect();
  dispatch(fetchBondNumbersLanding());
  dispatch(fetchBondNumbersPool());
  dispatch(fetchBondNumbersPlayers({ limit: 100 }));
  return socket;
};
